import { useQuery } from "@tanstack/vue-query";
import LeadSource from "@/services/lead-source";

export function useLeadSources() {
  return useQuery({
    queryKey: ["leadSources"],
    queryFn: async () => {
      const result = await LeadSource.getLeadSources({});

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to load lead sources");
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
